module.exports = __webpack_public_path__ + "static/media/validation-success.cac0fc45.svg";